import { Language, SupportedLanguages } from './types';
import {
  // AuLang,
  // CaLang,
  DeLang,
  EnLang,
  // EsLang,
  // FrLang,
  // GrLang,
  // ItLang,
  // NzLang,
  PtLang
  // SlLang
} from './svg/Languages';

export const languageOptions: Record<SupportedLanguages, Language> = {
  en: {
    icon: EnLang,
    labelCode: 'en',
    labelName: 'English',
    currency: 'EUR',
    title: 'en'
  },
  gb: {
    icon: EnLang,
    labelCode: 'gb',
    labelName: 'English',
    currency: 'GBP',
    title: 'en'
  },
  // au: {
  //   icon: AuLang,
  //   labelCode: 'au',
  //   labelName: 'English-AU',
  //   currency: 'EUR',
  //   title: 'au'
  // },
  // nz: {
  //   icon: NzLang,
  //   labelCode: 'nz',
  //   labelName: 'English-NZ',
  //   currency: 'EUR',
  //   title: 'nz'
  // },
  // ca: {
  //   icon: CaLang,
  //   labelCode: 'ca',
  //   labelName: 'English-CA',
  //   currency: 'EUR',
  //   title: 'ca'
  // },
  // es: {
  //   icon: EsLang,
  //   labelCode: 'es',
  //   labelName: 'Spanish',
  //   currency: 'EUR',
  //   title: 'es'
  // },
  // fr: {
  //   icon: FrLang,
  //   labelCode: 'fr',
  //   labelName: 'French',
  //   currency: 'EUR',
  //   title: 'fr'
  // },
  // el: {
  //   icon: GrLang,
  //   labelCode: 'el',
  //   labelName: 'Greek',
  //   currency: 'EUR',
  //   title: 'el'
  // },
  de: {
    icon: DeLang,
    labelCode: 'de',
    labelName: 'Deutsch',
    currency: 'EUR',
    title: 'de'
  },
  pt: {
    icon: PtLang,
    labelCode: 'pt',
    labelName: 'Portuguese',
    currency: 'EUR',
    title: 'pt'
  }
  // sl: {
  //   icon: SlLang,
  //   labelCode: 'sl',
  //   labelName: 'Slovenian',
  //   currency: 'EUR',
  //   title: 'sl'
  // },
  // pl: {
  //   icon: PlLang,
  //   labelCode: 'pl',
  //   labelName: 'Polish',
  //   currency: 'EUR',
  //   title: 'pl'
  // },
  // it: {
  //   icon: ItLang,
  //   labelCode: 'it',
  //   labelName: 'Italian',
  //   currency: 'EUR',
  //   title: 'it'
  // },
  // ro: {
  //   icon: RoLang,
  //   labelCode: 'ro',
  //   labelName: 'Romanian',
  //   currency: 'EUR',
  //   title: 'ro'
  // }
};
